import React from "react";
import { List, Datagrid, TextField, EditButton } from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from '../Actions'

export const ProjectList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role
    ? role === SUPERADMIN
      ? {}
      : { _id: project }
    : { _id: project };
  return (
    <List
      {...props}
      title="project.project"
      bulkActions={false}
      actions={<Actions create />}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <div />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/project/ProjectList.js